import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { updateEnvironmentHash } from 'tradera-state/environment/actions';

const ALink = ({
    useLink,
    href,
    children,
    onClick: givenOnClick,
    ...otherProps
}) => {
    const dispatch = useDispatch();
    const isSpaNavigationEnabled = useSelector(
        state => state.environment.isSpaNavigationEnabled
    );
    if (isSpaNavigationEnabled && useLink) {
        // Strip away origin for local links
        let to = href;
        if (href?.startsWith(location.origin)) {
            const { pathname, search } = new URL(href);
            to = pathname + search;
        }
        return (
            <Link
                to={to}
                {...otherProps}
                onClick={evt => {
                    dispatch(updateEnvironmentHash());
                    if (givenOnClick) givenOnClick(evt);
                }}>
                {children}
            </Link>
        );
    } else {
        return (
            <a href={href} {...otherProps}>
                {children}
            </a>
        );
    }
};

export default ALink;
